// extracted by mini-css-extract-plugin
export default {"cls1":"zDMR6Viz9xOuwZqeqFfm","cls2":"U1Qo4Fo89E5nuncr6N1M zDMR6Viz9xOuwZqeqFfm","isTabletUp":"nqCJT2YszucgwD4rJnbx"};